import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import { Form, Icon, Input, Button, message, Modal } from 'antd';
const FormItem = Form.Item;
import authorizationLogin from '../../action/authorization/login'
import getMobileCode from '../../action/login/getMobileCode'
import queryString from 'query-string'
import {CLOSE_TIME, API_CODE_SUCCESS, API_ROOT} from '../../config'

import CaptchaInput from '../../components/common/Captcha'
import ForgetPasswordForm from '../../components/login/forgetPasswordForm'

class NormalLoginForm extends Component {

	static propTypes = {
		login: PropTypes.func,
    getMobileCode: PropTypes.func,
	}

	constructor(props) {
		super(props)
		this.state = {
			showCaptcha: false,
			isReSet: '',
			visible: false,
      mobileCodeVisible: false,
		}
	}
  showModal = () => {
    this.setState({visible: true});
  }
	handleCancel = () => {
		this.setState({visible: false});
	}

  handleCloseMobileCodeModal = () => {
    this.setState({mobileCodeVisible: false});
  }

	// 登录请求
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			const {userName, password, mobileCode} = values
			const {redirect_uri, client_id, state} = this.props
			const params = {
				userName: btoa(userName),
				password: btoa(password),
        mobileCode: btoa(mobileCode),
				redirect_uri,
				client_id,
				state
			}
			if (!err) {
				this.props.authorizationLogin(params).then(({retCode, retMsg, retData}) => {
					if (retCode === API_CODE_SUCCESS) {
						const params = queryString.parse(location.search)
						message.success(retMsg, CLOSE_TIME, () => {
							if (typeof retData.url !== 'undefined') {
								location.href = retData.url
							}
						})
					} else {
						message.error(retMsg, CLOSE_TIME)
					}
				})
			}
		});
	}


  /***
   * 获取验证码逻辑：
   * 先根据用户名，密码 获取手机验证码 如果密码错误，则出现图片验证码；
   * 拿到手机验证码之后，再根据验证码，用户，密码登录OA
   */
  handleGetMobileCode = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const {userName, password, captcha = ''} = values
      if (!err) {
        this.props.getMobileCode({
          userName: btoa(userName),
          password: btoa(password),
          captcha
        }).then(({retCode, retMsg}) => {
          if (retCode === API_CODE_SUCCESS) {
            // 弹出 modal 手机验证码
            this.setState({
              mobileCodeVisible: true
            })
          } else if (retCode == '80001') {
            const {redirect_uri, client_id, state} = this.props
            const params = {
              userName: btoa(userName),
              password: btoa(password),
              redirect_uri,
              client_id,
              state
            }
            this.props.authorizationLogin(params).then(({retCode, retMsg, retData}) => {
              if (retCode === API_CODE_SUCCESS) {
                message.success(retMsg, CLOSE_TIME, () => {
                  if (typeof retData.url !== 'undefined') {
                    location.href = retData.url
                  }
                })
              } else {
                message.error(retMsg, CLOSE_TIME)
              }
            })
          } else {
            this.setState({isReSet: Math.floor(Math.random() * (999 - 1) + 1)})
            if (retCode == '10005' || retCode == '30003') {
              message.error(retMsg, CLOSE_TIME)
              this.setState({showCaptcha: true})
            } else {
              message.error(retMsg, CLOSE_TIME)
            }
          }
        })
      }
    });
  }

	render() {
		const { getFieldDecorator } = this.props.form
		const {showCaptcha} = this.state

		return (
			<div>
				<Form onSubmit={this.handleGetMobileCode} className="login-form">

          <Modal
            title="已向当前账号所绑定手机号发送验证码，请输入验证码校验"
            visible={this.state.mobileCodeVisible}
            onOk={this.handleSubmit}
            onCancel={this.handleCloseMobileCodeModal}
            maskClosable={false}
          >
            <FormItem label="验证码">
              {getFieldDecorator('mobileCode', {
                rules: [
                  {
                    required: this.state.mobileCodeVisible,
                    message: '请输入验证码'
                  },
                ],
              })(
                <Input
                  size="large"
                  style={{width:280}}
                  placeholder="请输入验证码"
                />
              )}
            </FormItem>
          </Modal>

					<FormItem>
						{getFieldDecorator('userName', {
							rules: [{ required: true, message: '请输入用户名!' }],
						})(
								<Input prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="用户名" />
						)}
					</FormItem>
					<FormItem>
						{getFieldDecorator('password', {
							rules: [{ required: true, message: '请输入密码!' }],
						})(
								<Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="密码" />
						)}
					</FormItem>
					<FormItem style={{display: showCaptcha ? 'block' : 'none'}}>
						{getFieldDecorator('captcha', {
							rules: [{ required: showCaptcha, message: '请输入验证码!', len: 4}],
						})(
								<CaptchaInput isReSet={this.state.isReSet}/>
						)}
					</FormItem>
					<FormItem>
						<a className="login-form-forgot-link" href="javascript:;" onClick={this.showModal}>忘记密码</a>
						<Button type="primary" htmlType="submit" className="login-form-button">
							登录
						</Button>
					</FormItem>
				</Form>
				<ForgetPasswordForm
						className="login-form-forgot-modal"
						visible={this.state.visible}
						onCancel={this.handleCancel}
					/>
			</div>	
		);
	}
}


const mapStateToProps = ({page, query}) => {
	const {isLoginIng} = page
	const { redirect_uri = '', client_id = '', state = '' } = query
	return {
		isLoginIng,
		redirect_uri,
		client_id,
		state
	}
}
const mapDispatchToProps = (dispatch) => {
  return {
    authorizationLogin: (params) => dispatch(authorizationLogin(params)),
    getMobileCode: (params) => dispatch(getMobileCode(params)),
  }
}

const WrappedNormalLoginForm = Form.create()(NormalLoginForm)

export default connect(mapStateToProps, mapDispatchToProps)(WrappedNormalLoginForm)


// WEBPACK FOOTER //
// ./src/components/authorization/index.js